// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table th.registration-symbol,\n.el-table td.registration-symbol {\n  width: 8em;\n}", ""]);
// Exports
module.exports = exports;
